<template>
    <Problems/>
</template>
<script>
import Problems from 'place/search/problems.vue'
export default {
    components:{
      Problems
    }
}
</script>
<style scoped>
</style>